export default product => {
  const products = ['book', 'bookshelf', 'lecture', 'collecture', 'vacancy']

  return products.includes(product)
}
